export function AuroraBackground() {
  return (
    <div className="aurora-container" aria-hidden="true">
      <div className="blob blob-1" />
      <div className="blob blob-2" />
      <div className="blob blob-3" />
    </div>
  )
}
